import type { ParticipationCapabilities } from './ParticipationLayer';

export const EXTERNAL_PARTICIPANT_TYPES = [
    'external_agent',
    'openclaw',
    'integration_bot',
    'remote_operator',
] as const;

export type ExternalParticipantType = typeof EXTERNAL_PARTICIPANT_TYPES[number];

export interface ExternalParticipantSession {
    sessionId: string;
    roomId: string;
    alias: string;
    participantType: ExternalParticipantType;
    joinedAt: string;
    capabilities: ParticipationCapabilities;
}
